/**
 * Gitterkorb add-on: when checked, adds 39.95 to price__regular and 29.96 to price__auto-discount.
 * Actual fee application is handled via Cart Transform function at checkout.
 */
(function () {
  const ADDON_REGULAR_CENTS = 3995; // 39.95 added to price__regular
  const ADDON_AUTO_DISCOUNT_CENTS = 2996; // 29.96 added to price__auto-discount
  const DISCOUNT_FACTOR_PERCENT = 75; // matches product-price.liquid (75% = 25% off)

  function getFormat() {
    if (typeof theme !== 'undefined' && theme.settings) {
      return theme.settings.currencyCodeEnabled
        ? theme.settings.moneyWithCurrencyFormat
        : theme.settings.moneyFormat;
    }
    return '';
  }

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, getFormat());
    }
    return (cents / 100).toFixed(2);
  }

  function baseAutoDiscountFromRegular(regularCents) {
    return Math.floor((regularCents * DISCOUNT_FACTOR_PERCENT + 50) / 100);
  }

  function updatePriceDisplay(checkbox, variantPrice, sectionId, productId) {
    const baseRegular = parseInt(variantPrice, 10) || 0;
    const baseAutoDiscount = baseAutoDiscountFromRegular(baseRegular);
    const addonChecked = checkbox && checkbox.checked;

    const displayRegular = addonChecked ? baseRegular + ADDON_REGULAR_CENTS : baseRegular;
    const displayAutoDiscount = addonChecked ? baseAutoDiscount + ADDON_AUTO_DISCOUNT_CENTS : baseAutoDiscount;

    const priceSelectors = [
      `#Price-${sectionId}-${productId}`,
      `#StickyPrice-${sectionId}-${productId}`,
      `#BuyButtonPrice-${sectionId}-${productId}`
    ];

    priceSelectors.forEach((selector) => {
      const container = document.querySelector(selector);
      if (!container) return;

      const priceRegular = container.querySelector('.price__regular');
      const priceAutoDiscount = container.querySelector('.price__auto-discount');
      const buyPriceEl = container.querySelector('product-buy-price');

      if (priceRegular) {
        priceRegular.textContent = formatMoney(displayRegular);
      }
      if (priceAutoDiscount) {
        priceAutoDiscount.textContent = formatMoney(displayAutoDiscount);
      }
      if (buyPriceEl) {
        buyPriceEl.textContent = formatMoney(displayRegular);
      }
    });
  }

  function initForCheckbox(checkbox) {
    if (!checkbox) return;

    const formId = checkbox.getAttribute('form');
    if (!formId) return;

    const form = document.getElementById(formId);
    if (!form) return;

    const prefix = 'ProductForm-';
    if (!formId.startsWith(prefix)) return;
    const rest = formId.slice(prefix.length);
    const lastDash = rest.lastIndexOf('-');
    if (lastDash === -1) return;
    const sectionId = rest.slice(0, lastDash);
    const productId = rest.slice(lastDash + 1);

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    let lastBasePrice = 0;

    function refreshFromVariant() {
      const variantId = variantInput.value;
      if (!variantId) return;

      // 1) Try to read base price from inline <product-buy-price> (used on some templates)
      const buyPriceEl = document.querySelector(`product-buy-price[form="${formId}"]`);
      const dataPrice = buyPriceEl?.getAttribute('data-price');
      if (dataPrice) {
        lastBasePrice = parseInt(dataPrice, 10) || 0;
        updatePriceDisplay(checkbox, lastBasePrice, sectionId, productId);
        return;
      }

      // 2) Fallback: use already-rendered variant JSON in the current product-info (works in modal/quick view)
      const productInfoId = `ProductInfo-${sectionId}-${productId}`;
      const productInfoEl = document.getElementById(productInfoId);
      const inlineVariantJson = productInfoEl?.querySelector('[data-selected-variant]') || document.querySelector('[data-selected-variant]');
      if (inlineVariantJson) {
        try {
          const inlineVariant = JSON.parse(inlineVariantJson.textContent || '{}');
          if (inlineVariant && typeof inlineVariant.price === 'number') {
            lastBasePrice = inlineVariant.price;
            updatePriceDisplay(checkbox, lastBasePrice, sectionId, productId);
            return;
          }
        } catch (e) {
          // ignore and fall through to network fetch
        }
      }

      // 3) Last resort: fetch the section HTML in the context of the current page and read the selected variant
      fetch(`${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const variantJson = doc.querySelector('[data-selected-variant]');
          const variant = variantJson ? JSON.parse(variantJson.textContent) : null;
          const price = variant ? variant.price : 0;
          lastBasePrice = price;
          updatePriceDisplay(checkbox, price, sectionId, productId);
        })
        .catch(() => {});
    }

    function onVariantChange(e) {
      const variant = e.detail?.variant;
      const price = variant ? variant.price : 0;
      lastBasePrice = price;
      updatePriceDisplay(checkbox, price, sectionId, productId);
    }

    function onAddonChange() {
      updatePriceDisplay(checkbox, lastBasePrice, sectionId, productId);
    }

    checkbox.addEventListener('change', onAddonChange);
    const addonContainer = checkbox.closest('.product__gitterkorb-addon') || document.querySelector('.product__gitterkorb-addon');
    if (addonContainer) {
      addonContainer.addEventListener('change', onAddonChange);
    }

    (form || document).addEventListener('variant:change', onVariantChange);
    document.addEventListener('variant:change', onVariantChange);

    setTimeout(refreshFromVariant, 150);
  }

  function initAll() {
    const checkboxes = document.querySelectorAll('[data-gitterkorb-addon]');
    if (!checkboxes.length) return;
    checkboxes.forEach((checkbox) => {
      if (checkbox.dataset.gitterkorbInitialized === 'true') return;
      initForCheckbox(checkbox);
      checkbox.dataset.gitterkorbInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor / dynamic section loads
  document.addEventListener('shopify:section:load', initAll);
  // Quick-view modal loads product HTML via AJAX and reinjects scripts
  document.addEventListener('quickview:loaded', initAll);
})();
